import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import Select from 'react-select'
import { fetchData, formatNumber, toasterrormsg } from '../../../reusable'
import { KTIcon } from '../../../_metronic/helpers'
import Loader from '../component/Loader'
import { PageTitle } from '../../../_metronic/layout/core'
import { Tr } from '../../../_metronic/i18n/Tr'

const ViewRevenueList: FC = () => {

  const t = Tr()
  const categoryId = sessionStorage.getItem('categoryId');
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;
  } else {
    console.log("No vendor data found");
  }
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(5)
  const [revenueList, setRevenueList] = useState([])
  const [orgRevenueList, setOrgRevenueList] = useState([])
  const [totalRecords, setTotalRecords] = useState('') as any
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const yearTypeList = [
    { label: t('All'), value: 'All' },
    { label: t('Yearly'), value: 'Yearly' }
  ]
  const [yearTypeSelectedOptions, setYearTypeSelectedOption] = useState({}) as any;
  useEffect(() => {
    setYearTypeSelectedOption({
      value:'All',
      label: t('All') // Re-apply current translation
    });
  }, [t('All')]);
  const [yearList, setYearList] = useState([])
  const [yearSelectedOptions, setYearSelectedOption] = useState() as any;
  const [monthList] = useState([
    { value: '0', label: 'ALL' },
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ]) as any
  const [selectedMonth, setSelectedMonth] = useState("") as any
  const [totalFinalAmount, setTotalFinalAmount] = useState('')
  const [totalInsayrServiceFee, setTotalInsayrServiceFee] = useState('')
  const [totalVendorRevenue, setTotalVendorRevenue] = useState('') as any

  // generate list of years from vendor created years to current tear
  const generateYearList = (startYear: any) => {
    const currentYear = moment().year();
    const years = [] as any;

    for (let year = currentYear; year >= startYear; year--) {
      years.push({ label: year.toString(), value: year.toString() });
    }

    setYearList(years);
  };

  //  revenue list api call
  const revenueListApiCall = async (
    limit1?: any,
    offset1?: any,
  ) => {
    setIsLoading(true)
    var param: any = {
      vendorId: String(vendorId),
      categoryId: categoryId,
      limit: limit1,
      offset: offset1,
    }
    if (yearSelectedOptions) {
      param['year'] = yearSelectedOptions.value
    }
    if (selectedMonth) {
      param['month'] = selectedMonth
    }
    var res = await fetchData('public/revenueReports', param)
    if (res.status == '200') {
      setIsLoading(false)
      var data = res.data
      setRevenueList(data.data)
      setTotalRecords(data.totalRecords)
      setOrgRevenueList(data.data)
    } else {
      toasterrormsg(res.message)
    }
  }

  const delatiledRevenueReportTotalApiCall = async () => {

    var param: any = {
      vendorId: String(vendorId),
      categoryId: categoryId,
    }
    if (yearSelectedOptions) {
      param['year'] = yearSelectedOptions.value
    }
    if (selectedMonth) {
      param['month'] = selectedMonth
    }
    var res = await fetchData('public/revenueReportsTotal', param)

    if (res.status == '200') {
      var data = res.data
      setTotalFinalAmount(data.totalAmount != "" ? data.totalAmount : "")
      setTotalInsayrServiceFee(data.insayrFee != "" ? data.insayrFee : "")
      setTotalVendorRevenue(data.insayrRevenue >= 0 && data.totalAmount >= 0 ? parseFloat(data.totalAmount) - parseFloat(data.insayrRevenue) : '0')
    } else {
      toasterrormsg(res.message)
    }
  }

  // view profile api call
  const viewprofile = async () => {
    var param: any = {
      vendorId: String(vendorId),
    }
    var response: any = await fetchData("public/viewProfile", param)
    if (response.status == "200") {
      var data = response.data[0]
      generateYearList(moment(data).format('YYYY'))
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    viewprofile()
  }, [])

  const handlePageChange = (newPage: number) => {
    const newOffset = (newPage - 1) * limit;
    setOffset(newOffset);
    revenueListApiCall(limit, newOffset);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage);
    revenueListApiCall(newRowsPerPage, offset);
  };
  // search Data
  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setRevenueList(orgRevenueList)
    } else {
      var tmp: any = orgRevenueList.filter((item: any) => {
        return (
          (item.bookingCode != null &&
            item.bookingCode != '' &&
            String(item.bookingCode).toLocaleLowerCase().includes(text)) ||
          (item.toDate != null &&
            item.toDate != '' &&
            String(item.toDate).toLowerCase().includes(text.toLowerCase())) ||
          (item.originalAmount != null &&
            item.originalAmount != '' &&
            String(item.originalAmount).toLowerCase().includes(text.toLowerCase())) ||
          (item.bookingUserName != null &&
            item.bookingUserName != '' &&
            String(item.bookingUserName).toLowerCase().includes(text.toLowerCase())) ||
          (item.totalAmount != null &&
            item.totalAmount != '' &&
            String(item.totalAmount).toLowerCase().includes(text.toLowerCase())) ||
          (item.insayrFee != null &&
            item.insayrFee != '' &&
            String(item.insayrFee).toLowerCase().includes(text.toLowerCase()))
        )
      })

      setRevenueList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {

      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex flex-wrap'>
          <Select
            className='m-1 w-150px'
            options={yearTypeList}
            value={yearTypeSelectedOptions}
            placeholder={t('Select')}
            onChange={(e: any) => { setYearTypeSelectedOption(e); setYearSelectedOption() }}
          />
          {
            yearTypeSelectedOptions && yearTypeSelectedOptions.value == 'Yearly' && (
              <Select
                className='m-1 w-150px'
                options={yearList}
                value={yearSelectedOptions}
                placeholder={t('Select Year')}
                onChange={(e: any) => setYearSelectedOption(e)}
              />
            )
          }
          {
            yearSelectedOptions && (
              <Select
                className='m-1 w-150px'
                name='month'
                id='month'
                placeholder={t('Select Month')}
                isSearchable={true}
                isClearable={true}
                options={monthList}
                value={monthList.find(
                  (option: any) => option.value == selectedMonth
                ) || ""}
                onChange={(e: any) => { setSelectedMonth(e ? e.value : ''); }}
              />
            )
          }
        </div>
      </div>
    )
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: t('Booking Id'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.bookingCode != 'totalRecords' ? (
              <>
                <div className='fw-bold fs-5 text-primary under text-decoration-underline cursor-pointer'>
                  <Link
                    to={
                      row.categoryId == '1'
                        ? '../viewhotelbookingdetails'
                        : row.categoryId == '4'
                          ? '../viewspacebookingdetails'
                          : row.categoryId == '5'
                            ? '../viewtourbookingdetails'
                            : row.categoryId == '7'
                              ? '../viewcarbookingdetails'
                              : ''
                    }
                    state={{
                      bookingId: row.bookingId,
                    }}
                  >
                    #{row.bookingCode || ''}
                  </Link>{' '}
                </div>{' '}
              </>
            ) : (
              <div className='fw-bold'> {totalRecords}</div>
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => Number(row.bookingCode),
        width: '200px',
      },
      {
        name: t('Customer Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.bookingUserName != '' ? row.bookingUserName : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.bookingUserName),
        filter: true,
        width: '222px',
      },
      {
        name: categoryId == "5" ? t("Tour Date") : categoryId == "4" ? t("Renting Date") : categoryId == "7" ? t('Drop Off Date') : t('Check Out Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId != 5 && row.toDate != '' && row.toDate != 'Total' ? moment(row.toDate).format("DD-MM-YYYY") : row.toDate != 'Total' ? moment(row.fromDate).format("DD-MM-YYYY") : ''}
              {row.toDate == 'Total' ? t('Total') : ''}{' '}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.toDate),
        sortFunction: (rowA: any, rowB: any) => {
          const dateA = rowA.toDate ? new Date(rowA.toDate) : null;
          const dateB = rowB.toDate ? new Date(rowB.toDate) : null;

          // Handle the case where one or both dates are empty
          if (!dateA && !dateB) return 0; // Both dates are empty
          if (!dateA) return 1;            // Empty dates go to the end (you can change this to -1 if you want empty first)
          if (!dateB) return -1;

          // Sorting logic: Ascending or Descending based on the click
          if (dateA < dateB) return -1; // Ascending
          if (dateA > dateB) return 1;  // Descending
          return 0;
        },
        filter: true,
        width: '222px',
      },
      {
        name: t('Service Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId == '1'
                ? t('Accommodation')
                : row.categoryId == '4'
                  ? t('Space Rental')
                  : row.categoryId == '5' ? t('Tour Package')
                    : row.categoryId == '7' ? t('Car Rental')
                      : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },
      {
        name: `${categoryId == '1' ? t('Accommodation Name') : categoryId == '4' ? t('Space Name') : categoryId == '5' ? t('Tour Agency Name') : categoryId == '7' ? t('Supplier Name') : ''}`,
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.actionName != '' ? row.actionName : '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.actionName),
        filter: true,
        width: '222px',
      },
      {
        name: `${categoryId == '5' ? t('Tour Type') : categoryId == '7' ? t('Car Type') : t('Property Type')}`,
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.propertyname != '' ? row.propertyname : '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.propertyname),
        filter: true,
        width: '222px',
      },
      {
        name: t('Booking Status'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.bookingStatus == 0 ? (
              <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Pending')}</span>
            ) : row.bookingStatus == 1 ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Approved')}</span>
            ) : row.bookingStatus == 2 ? (
              <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Rejected')}</span>
            ) : row.bookingStatus == 3 ? (
              <>
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Cancelled')}</span> <br />
                <div className='text-center mt-2'>
                  {' '}
                  <span className='fw-bold fs-6'>
                    ({row.cancellationCharge ? row.cancellationCharge + `% ${t('Charges')}` : `0% ${t('Charges')}`})
                  </span>
                </div>
              </>
            ) : row.bookingStatus == 4 ? (
              <span className='btn btn-success mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Completed')}</span>
            ) : (
              <div className='fw-bold fs-5'>-</div>
            )}
          </div>
        ),
        sortable: true,
        filter: true,
        width: '180px',
        selector: (row: any) => String(row.bookingStatus),
      },
      {
        name: t('Original Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.originalAmount >= 0 ? formatNumber(parseFloat(row.originalAmount)) + ' UZS' : '--'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.originalAmount),
        filter: true,
        width: '170px',
      },
      {
        name: t('Final Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount >= 0 ? formatNumber(parseFloat(row.totalAmount)) + ' UZS' : '--'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.totalAmount),
        filter: true,
        width: '170px',
      },
      {
        name: t('Insayr Service Fee (%)'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.insayrFee != '' ? row.insayrFee + '%' : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.insayrFee),
        filter: true,
        width: '200px',
      },
      {
        name: t('Vendor Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.bookingCode !== 'totalRecords' ? (
                row.bookingStatus != 2 && row.insayrRevenue >= 0 && row.totalAmount >= 0 ? (
                  `${formatNumber(parseFloat(row.totalAmount) - parseFloat(row.insayrRevenue))} UZS`
                ) : (
                  '0 UZS'
                )
              ) : (
                formatNumber(parseFloat(row.vendorRevenue)) + ' UZS'
              )}
            </div>
          </div>
        ),
        width: '170px',
      },
      {
        name: t('Vendor Payment Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {
                row.bookingCode != 'totalRecords' ? (
                  <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
                    <span className='badge badge-warning mx-2'>{t('Pending')}</span>
                  </label>
                ) : ('--')
              }
            </div>
          </div>
        ),
      },
    ],
    [t]
  )
  useEffect(() => {
    revenueListApiCall(limit, offset)
    delatiledRevenueReportTotalApiCall()
  }, [yearSelectedOptions, yearTypeSelectedOptions, selectedMonth])

  const customRow = {
    bookingCode: 'totalRecords',
    bookingUserName: '',
    fromDate: '',
    toDate: 'Total',
    categoryId: 'NA',
    actionName: '',
    propertyname: '',
    bookingStatus: 'NA',
    totalAmount: totalFinalAmount,
    insayrFee: totalInsayrServiceFee,
    vendorRevenue: totalVendorRevenue,
    paymentStatus: '',
  };
  const dataWithCustomRow = useMemo(() => {
    return [...revenueList, customRow];
  }, [revenueList, totalFinalAmount, totalInsayrServiceFee]);
  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Revenue List')}</PageTitle>
      {
        <div className="card card-flush py-4">
          <div className="card-body pt-0">
            <DataTable
              columns={column}
              data={revenueList.length > 0 ? dataWithCustomRow : revenueList}
              pagination
              paginationServer={true}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />
              }
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              paginationTotalRows={totalRecords}
              paginationPerPage={limit}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
            />
          </div>
        </div>
      }
    </>
  )
}

export { ViewRevenueList }
